import React from 'react'
import styles from './BreadCrumb.module.css';
import dashboardIcon from '../../assets/image/dashboard-images/home 1.png'
import dipsIcon from '../../assets/image/dashboard-images/dipsIcon.png'
import trendsIcon from '../../assets/image/dashboard-images/TrendsIcon.png'
import stocks360Icon from '../../assets/image/dashboard-images/global-economy 1.png'
import ETFIcon from '../../assets/image/dashboard-images/ETFIcon.png'
import FnOIcon from '../../assets/image/dashboard-images/chart 1.png'
import equitiesIcon from '../../assets/image/dashboard-images/private-equity 1.png'
import upstoxIcon from '../../assets/image/dashboard-images/ready-stock 1.png'
import bondsIcon from '../../assets/image/dashboard-images/money 1.png'
import { FiChevronsLeft, FiChevronsRight } from "react-icons/fi";
import { useHistory } from 'react-router-dom';

const HomeBreadcrumbs = (props) => {

    const history = useHistory();

    const breadcrumbs_tiles = [
        { id: 0, icon: dipsIcon, title: "Dips", path: "/home/dip", enabled: true },
        { id: 1, icon: trendsIcon, title: "Trends", path: "/home/trend", enabled: true },
        { id: 2, icon: stocks360Icon, title: "Stocks 360", path: "", enabled: false },
        { id: 3, icon: ETFIcon, title: "Past Performance", path: "", enabled: false },
        { id: 4, icon: FnOIcon, title: "Feedback", path: "", enabled: false },
        { id: 5, icon: equitiesIcon, title: "Breakouts", path: "", enabled: false },
        { id: 6, icon: upstoxIcon, title: "Patterns", path: "", enabled: false },
        { id: 7, icon: bondsIcon, title: "Customer Support", path: "", enabled: false },
    ];

    return (
        <div className={styles.home_breadcrumb_container}>

            {breadcrumbs_tiles.map((tile, index) => (
                <div className={styles.breadcrumb_page_btn} key={index} onClick={() => history.push(tile.path)}>
                    <div className={`${styles.page_icon_container} ${tile.enabled ? styles.enabled_page_icon_container : ''} ${props.activeIndex === tile.id ? styles.active_icon_container : ''}`}
                    >
                        <img src={tile.icon} alt="dips" />
                    </div>
                </div>
            ))}

        </div>
    )
}

export default HomeBreadcrumbs